import * as dashboard from './types';

const getters = {
  [dashboard.STATISTICS]: state => state.statistics,
};

export default getters;
